/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
import ES from './es';
import EN from './en';
import DE from './de';
import FR from './fr';
import RU from './ru';
import ZH from './zh';
import JA from './ja';
import PT from './pt';
import IT from './it';
import HI from './hi';
import KO from './ko';

interface LanguageBundle {
  [key: string]: {
    [key: string]: string;
  };
}

const Bundle: LanguageBundle = {
  es: ES,
  en: EN,
  de: DE,
  fr: FR,
  ru: RU,
  zh: ZH,
  ja: JA,
  pt: PT,
  it: IT,
  hi: HI,
  ko: KO,
};

export default Bundle;
